const Personal = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/PersonalDetails");

const Additional = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/AdditionalDetails");
const Association = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/AssociationDetails");
const Clinic = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/ClinicDetails");

const Qualifications = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/QualificationsSpecialities");

const Residential = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/ResidentialDetails");

const PersonalSummary = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/summary/PersonalDetails");

const AdditionalSummary = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/summary/AdditionalDetails");

const AssociationSummary = () =>
    import ( /* webpackChunkName: "DoctorRegister" */ "@/components/registration/doctor/summary/AssociationDetails");

const ClinicSummary = () =>
    /* webpackChunkName: "DoctorRegister" */
    "@/components/registration/doctor/summary/ClinicDetailsSummary";

const QualificationsSummary = () =>
    import (
        /* webpackChunkName: "DoctorRegister" */
        "@/components/registration/doctor/summary/QualificationsSpecialitiesSummary"
    );

const ResidentialSummary = () =>
    import (
        /* webpackChunkName: "DoctorRegister" */
        "@/components/registration/doctor/summary/ResidentialDetails");

export default [{
        path: "",
        // name: "register.doctor.root",
        redirect: {
            name: "register.doctor.owner"
        }
    },
    {
        path: "personal",
        name: "register.doctor.owner",
        component: Personal
    },
    {
        path: "additional",
        name: "register.doctor.additional",
        component: Additional
    },
    {
        path: "associations",
        name: "register.doctor.association",
        component: Association
    },
    {
        path: "clinics",
        name: "register.doctor.clinic",
        component: Clinic
    },
    {
        path: "qualifications",
        name: "register.doctor.qualifications",
        component: Qualifications
    },
    {
        path: "residential",
        name: "register.doctor.residential",
        component: Residential
    },
    {
        path: "summary",
        name: "register.doctor.summary",
        redirect: {
            name: "register.doctor.summary.owner"
        },
        component: {
            render(c) {
                return c("router-view");
            }
        },
        children: [{
                path: "personal",
                name: "register.doctor.summary.owner",
                component: PersonalSummary
            },
            {
                path: "additional",
                name: "register.doctor.summary.additional",
                component: AdditionalSummary
            },
            
            {
                path: "associations",
                name: "register.doctor.summary.association",
                component: AssociationSummary
            },
            
            {
                path: "clinics",
                name: "register.doctor.summary.clinic",
                component: ClinicSummary
            },
            {
                path: "qualifications",
                name: "register.doctor.summary.qualifications",
                component: QualificationsSummary
            },
            {
                path: "residential",
                name: "register.doctor.summary.residential",
                component: ResidentialSummary
            }
        ]
    }
];